import { useMutation } from '@tanstack/react-query';
import { SKIP_FORBIDDEN_HEADER } from '@sentinel/api-client';
import { useApi } from '../../lib/api';

export interface StepUpGrantError extends Error {
  status?: number;
  body?: { error?: string };
}

export function useStepUpGrant() {
  const api = useApi();
  return useMutation({
    mutationFn: async ({
      ticket,
    }: {
      ticket: string;
    }): Promise<{ granted: boolean; expires_in: number }> => {
      const { data, error, response } = await api.POST('/auth/mcp/step-up-grants', {
        body: { ticket },
        // This page renders its own 403 (ticket of another account); skip the global toast.
        headers: { [SKIP_FORBIDDEN_HEADER]: '1' },
      });
      if (error) {
        const e = new Error('mcp_step_up_grant_failed') as StepUpGrantError;
        e.status = response?.status;
        e.body = error as { error?: string };
        throw e;
      }
      return data as { granted: boolean; expires_in: number };
    },
  });
}
